import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import type { Database } from "@/integrations/supabase/types";

type AppRole = Database["public"]["Enums"]["app_role"];

const roleHomeMap: Record<AppRole, string> = {
  admin: "/",
  gestor: "/",
  supervisor: "/",
  visualizacao: "/indicadores",
  promotor: "/execucao",
};

function getHomeForRoles(roles: AppRole[]): string {
  for (const role of roles) {
    if (roleHomeMap[role]) return roleHomeMap[role];
  }
  return "/configuracoes";
}

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: AppRole[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { session, loading, roles } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    // Block access if roles haven't loaded yet or user lacks permission
    if (roles.length === 0) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        </div>
      );
    }
    const hasAccess = allowedRoles.some((role) => roles.includes(role));
    if (!hasAccess) {
      const home = getHomeForRoles(roles);
      return <Navigate to={home} replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
